import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SupplementaryAccountsService } from 'src/app/core/services/supplementary-accounts.service';
import { EditSupplementaryAccount } from 'src/app/core/interface/auth.model';
import { DatePipe } from '@angular/common';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { environment } from 'src/environments/environment';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-supplementary-account',
  templateUrl: './edit-supplementary-account.component.html',
  styleUrls: ['./edit-supplementary-account.component.scss']
})
export class EditSupplementaryAccountComponent implements OnInit, OnDestroy {

  @Input() userId;

  supplimentaryAccount: FormGroup;
  submitted: boolean = false;
  minDate: any;
  maxDate: any;
  imagePath: any;
  imgURL: any = environment.url;
  file: File;
  isImageError: boolean = false;
  isError: boolean = false;

  selectedUser: any;
  imageSizeError: boolean = false;
  cityList: any = [];
  selectedCity: any = [];
  userCategories: any;
  errorMessage: string = 'Something went wrong, please try again later.';
  dropdownSettings: any;
  imageErrorMsg: string = LITERALS.VALIDATION.IMAGE_VALIDATION;
  isSvgImageError: boolean = false;
  cityListSubscriber: Subscription;
  @ViewChild('angularMultiselect', { static: false }) angularMultiselect: any;

  constructor(
    private activeModal: NgbActiveModal,
    private supplementaryAccountService: SupplementaryAccountsService,
    private formBuilder: FormBuilder,
    private _profileService: ProfileService,
    private spinner: NgxSpinnerService,
    public datePipe: DatePipe,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.loadUserCategories();
    this.dropdownSettings = {
      singleSelection: true,
      text: "Select Country",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      noDataLabel: "No country found",
      classes: "form-control",
      labelKey: "name"
    };

    this.minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 18));
    // this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.minDate.setHours(0, 0, 0, 0);
    this.maxDate = new Date();

    this.supplimentaryAccount = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
      user_category_id: [null, [Validators.required]],
      email: [null, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
      birth_date: [new Date(new Date().setFullYear(new Date().getFullYear() - 18)), [Validators.required]],
      city: [null],
      status: [null, [Validators.required]]
    });


    // this.spinner.show();
    this.supplementaryAccountService.loadSupplementaryAccount(this.userId).subscribe(
      (response: any) => {
        // this.spinner.hide();
        if (response.success) {
          this.selectedUser = response.data.user;

          if (this.selectedUser.avatar)
            this.imgURL += this.selectedUser.avatar;
          else
            this.imgURL = null;
          if (this.selectedUser.locations && this.selectedUser.locations.country)
            this.getCitiesList(this.selectedUser.locations.country, true);

          this.supplimentaryAccount = this.formBuilder.group({
            name: [this.selectedUser.name, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.BUISNESS_NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
            user_category_id: [this.selectedUser.user_category_id, [Validators.required]],
            email: [this.selectedUser.email, Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
            birth_date: [new Date(this.selectedUser.birth_date), [Validators.required]],
            city: [null],
            status: [this.selectedUser.status, [Validators.required]]
          });
        }
      }, (error: any) => {
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this.isError = true;
      });
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  closeDialog() {
    this.activeModal.dismiss();
  }

  preview(files) {
    this.isImageError = false;
    this.imageSizeError = false;
    this.isSvgImageError = false;

    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.isImageError = true;
      return;
    }

    if (mimeType !== 'image/png' && mimeType !== 'image/jpeg' && mimeType !== 'image/gif') {
      this.isSvgImageError = true;
      return;
    }

    if (files[0].size / 1048576 > 5.0) {
      this.imageSizeError = true;
      return;
    }

    var reader = new FileReader();
    this.imagePath = files;
    this.file = files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
    this.isImageError = false;
    this.imageSizeError = false;
  }

  getCitiesList(event, isCitySelected) {
    if (event && event.length > 2) {
      if (this.cityListSubscriber) {
        this.cityListSubscriber.unsubscribe();
      }
      this.cityList = [];
      this.cityListSubscriber = this._profileService.getCountries(event).subscribe(
        (response: any) => {
          if (response.success) {
            this.cityList = response.data.countries;

            if (isCitySelected) {
              this.selectedCity = this.cityList.find((element) => {
                return element.name === this.selectedUser.locations.country
              });;
              const selectedCity = [
                this.selectedCity
              ];
              this.supplimentaryAccount.get('city').setValue(selectedCity, { onlySelf: true });
            }
          }
        }, (error: any) => {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
    }
  }

  clearData(e) {
    if (this.angularMultiselect && !this.angularMultiselect.filter) {
      this.cityList = [];
    }
  }

  onItemSelect(item: any) {
    this.selectedCity = item;
  }

  onItemDeselect(item) {
    this.selectedCity = null;
  }

  onSubmit() {
    this.supplimentaryAccount.patchValue({
      name: this.supplimentaryAccount.value['name'].trim()
    });

    if(this.selectedUser.user_turned_eighteen){
      const birth_date = this.supplimentaryAccount.controls.birth_date;
      birth_date.clearValidators();
      birth_date.updateValueAndValidity();
    }

    this.submitted = true;

    // if (this.supplimentaryAccount.invalid || !this.imgURL) {
    if (this.supplimentaryAccount.invalid) {
      return;
    }
    const params: EditSupplementaryAccount = {
      'supplementary_account': {
        ...this.supplimentaryAccount.value,
        locations_attributes: [
          {
            // city: this.selectedCity.name,
            country: (this.selectedCity && this.selectedCity.name) ? this.selectedCity.name : '',
            // latitude: this.selectedCity.latitude,
            // longitude: this.selectedCity.longitude,
            // state: this.selectedCity.state_name
          }
        ]
      }
    };

    if (this.file) {
      params.supplementary_account['avatar'] = this.file;
    }

    this.spinner.show();
    // params.supplementary_account.avatar = this.imgURL;
    params.supplementary_account.birth_date = this.datePipe.transform(params.supplementary_account.birth_date, 'dd/MM/yyyy');
    params.supplementary_account.user_type = this.selectedUser.userType ? this.selectedUser.userType : 'individual';

    this.supplementaryAccountService.updateSupplementaryUser(this.userId, params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.message;
          this.closeDialog();
          this.ngOnInit();
        }
        else {
          // this.errorMessage = response.message;
          this.isError = true;
        }
      }, (error: any) => {
        this.spinner.hide();
        // this.errorMessage = error.error;
        this.errorMessage = 'Something went wrong, please try again later.';
        this.isError = true;
      });
  }

  loadUserCategories() {
    this._profileService.loadUserCategory().subscribe(
      (response: any) => {
        if (response.success) {
          this.userCategories = response.data.user_category;
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {

      });
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9/]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE_DATE, "");
    // this.editProfileForm.controls.birth_date.setValue(filteredText);
    if (!event.target.readOnly && !event.target.disabled)
      event.target.value = filteredText;
    event.preventDefault();
  }

  ngOnDestroy() {
    if (this.cityListSubscriber) {
      this.cityListSubscriber.unsubscribe();
    }
  }
}
